// extracted by mini-css-extract-plugin
export default {"flex":"sites_flex__717zV","icon_wrapper":"sites_icon_wrapper__XPBpV"};